import React, { useState } from 'react'
import LoginContainer from './container'
import { Formik } from 'formik';
import { loginSchema } from 'utils/schema';
import { setPOSData, useLoginMutation } from './services';
import { useDispatch } from 'react-redux';

import { useLocation, useNavigate } from 'react-router-dom';

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [loginApi] = useLoginMutation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleFormSubmit = async (values) => {
        // Create a new payload so we don’t mutate the incoming 'values'
        const payload = {
          ...values,
          // if your env var is exactly "pos", spread in { app: 'pos' }
          ...(process.env.REACT_APP_BASE_ROUTE === '/pos' && { app: 'pos' }),
        };
        console.log(payload, 'payloadcheck');
      
        const loginResponse = await loginApi(payload);
      
        // If we got back data...
        const userData = loginResponse.data?.data;
        if (userData) {
          // Check for admin role
          if (userData.role === 'admin') {
            // Optionally: show some feedback to the user
            alert('Admin users are not allowed to log in here.');
            return; // stop further execution (no dispatch, no navigate)
          }
      
          // Non-admins: set in store and navigate
          dispatch(setPOSData(userData));
          if (userData?.vendor?.is_profile_completed === false || userData?.vendor?.is_profile_completed === 0) {
            navigate('/onboarding');
          } else {
            navigate('/');
          }
        // navigate('/');
        }
      };
      
      

    return (
        <>
            <Formik
                initialValues={{
                    email: '',
                    password: '',
                    rememberMe: false,
                }}
                validationSchema={loginSchema}
                onSubmit={handleFormSubmit}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    isSubmitting,
                }) => {
                    return (
                        <LoginContainer
                            showPassword={showPassword}
                            setShowPassword={setShowPassword}
                            handleSubmit={handleSubmit}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            values={values}
                            errors={errors}
                            touched={touched}
                            setFieldValue={setFieldValue}
                            isSubmitting={isSubmitting}
                          
                            // isLoading={isLoading}
                        />
                    );
                }}
            </Formik>
        </>
    )
}

export default Login
